export default (state) => state.authentication.sessionRequest
